<div class="copo-datacenter-filter">
	<label class="filter-number-label" for="filter-more-than-input" translate>filter.more-than</label>
	<div>
		<mat-form-field appearance="outline" class="copo-no-error-message filter-datacenter-text-container">
			<input matInput id="filter-more-than-input" type="text" spellcheck="false" autocomplete="off" [formControl]="moreThanTextControl" [placeholder]="'filter.more-than' | translate">
			<button type="button" *ngIf="moreThanTextControl.value" matSuffix mat-icon-button (click)="resetMoreThen()" tabindex="-1">
				<mat-icon svgIcon="md:close"></mat-icon>
			</button>
		</mat-form-field>
		<div class="info-invalid-value" *ngIf="!moreThanTextControl.valid" translate>datacenter-filter.invalid-number</div>
	</div>
	<label class="filter-number-label" for="filter-less-than-input" translate>filter.less-than</label>
	<div>
		<mat-form-field appearance="outline" class="copo-no-error-message filter-datacenter-text-container">
			<input matInput id="filter-less-than-input" type="text" spellcheck="false" autocomplete="off" [formControl]="lessThanTextControl" [placeholder]="'filter.less-than' | translate">
			<button type="button" *ngIf="lessThanTextControl.value" matSuffix mat-icon-button (click)="resetLessThen()" tabindex="-1">
				<mat-icon svgIcon="md:close"></mat-icon>
			</button>
		</mat-form-field>
		<div class="info-invalid-value" *ngIf="!lessThanTextControl.valid" translate>datacenter-filter.invalid-number</div>
	</div>
</div>
